import { ref } from 'vue';

const isCollapse = ref(false);
export default function useLayouts() {
  const toggleSidebar = (newVal) => {
    isCollapse.value = newVal;
    localStorage.setItem('isCollapse', newVal ? '1' : '0');
  };
  return { isCollapse, toggleSidebar };
}
